import { Signal } from '@preact/signals'
import Button from 'site/components/ui/Button.tsx'
import { SlimProduct } from 'site/types.ts'

interface SizesProps {
    product: SlimProduct
    selectedSkuIdSignal: Signal<string | null>
    hasTriedToBuy: Signal<boolean>
    options: [
        string,
        {
            isAvailable: boolean
            urls: string[]
        },
    ][]
    hasVariants: boolean
    layout?: 'buyModal'
}

const RenderSizesBuyModal = (props: SizesProps) => {
    const { product, selectedSkuIdSignal, hasTriedToBuy, options } = props

    return (
        <>
            <span class='block mb-1 text-[12px] text-grey-800'>Escolha seu tamanho:</span>
            <ul class='flex items-center gap-2 flex-wrap'>
                {options.map(([value, info]) => {
                    const url = info.urls.find((url) => url === product.url) || info.urls[0]
                    const skuId = url.split('=').pop()!
                    const isSelected = skuId === selectedSkuIdSignal.value

                    // Se houver a variação de SKU UN, já seta o selectedSkuIdSignal com o valor do Sku UN - ticket 0924-000055
                    if (value.toLocaleLowerCase() === 'un' && info.isAvailable) {
                        hasTriedToBuy.value = false
                        selectedSkuIdSignal.value = skuId
                    }

                    return (
                        <Button
                            data-tried-to-buy={hasTriedToBuy.value}
                            variant='variantSelector'
                            class='!border-[1px] data-[tried-to-buy=true]:!border-danger-500 disabled:bg-primary-700 disabled:text-white disabled:border-none disabled:!cursor-default'
                            disabled={isSelected}
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()

                                hasTriedToBuy.value = false
                                selectedSkuIdSignal.value = skuId
                            }}
                        >
                            {value}
                        </Button>
                    )
                })}
            </ul>
        </>
    )
}

function Sizes(props: SizesProps) {
    const { product, selectedSkuIdSignal, hasTriedToBuy, options, layout } = props

    if (!options || options.length === 0) {
        return null
    }

    if (layout === 'buyModal') {
        return <RenderSizesBuyModal {...props} />
    }

    return (
        <>
            <ul class='flex justify-center items-center gap-2 flex-wrap px-2'>
                {options.map(([value, info]) => {
                    const url = info.urls.find((url) => url === product.url) || info.urls[0]
                    const skuId = url.split('=').pop()!
                    const isSelected = skuId === selectedSkuIdSignal.value

                    return (
                        <Button
                            data-tried-to-buy={hasTriedToBuy.value}
                            variant='variantSelector'
                            class='!border-[1px] data-[tried-to-buy=true]:!border-danger-500 disabled:bg-primary-700 disabled:text-white disabled:border-none disabled:!cursor-default'
                            disabled={isSelected}
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()

                                hasTriedToBuy.value = false
                                selectedSkuIdSignal.value = skuId
                            }}
                        >
                            {value}
                        </Button>
                    )
                })}
            </ul>
        </>
    )
}

export default Sizes
